<div
  class="h-10 w-10 animate-spin select-none rounded-full border-8 border-t-french-blue-500"
  [class]="classOverrides || ''"
></div>
